import { defineRouting } from 'next-intl/routing';
import { LOCALES } from '@/_constants';
import { EXTERNAL_LOCALE } from '@/_constants/cookies';

export const routing = defineRouting({
  locales: Object.values(LOCALES),
  defaultLocale: 'ru',
  localePrefix: 'always',
  localeCookie: {
    name: EXTERNAL_LOCALE,
  },
});
